import Trans from '@/components/shared/Trans';
import translations from '../../Dashboard.trans.json';
import PendingEvents from '../PendingEvents';
import UnassignedInquiries from '../UnassignedInquiries';
import PendingContact from '../PendingContact';
import PendingLeads from '../PendingLeads';
import PendingReservations from '../PendingReservations';
import PortalsNotifications from '../PortalsNotifications';
import ExpiringRent from '../ExpiringRent';
import OverviewTasks from '../../DashboardOverview/RowCards/OverviewTasks';
import VisitsToConfirm from '../VisitsToConfirm';
import PropertiesPendingReview from '../PropertiesPendingReview';
import DevelopmentsPendingReview from '../DevelopmentsPendingReview';

export const componentsMap = {
  without_label: {
    EventsForToday: PendingEvents,
    OverviewTasks,
    UnassignedInquiries,
    ContactsToReachOut: PendingContact,
    ListingsAlertsErrors: PortalsNotifications,
    VisitsToConfirm,
    PropertiesPendingReview,
    DevelopmentsPendingReview,
  },
  UpcomingExpirations: {
    LeadsToExpire: PendingLeads,
    ReservationsToExpire: PendingReservations,
    RentToExpire: ExpiringRent,
  },
};

export const titlesMap = {
  without_label: null,
  UpcomingExpirations: Trans(translations, 'UpcomingExpirations'),
};
